export const useDescriptionText = (descriptions, language = 'spanish') => {
  const description = descriptions?.find(
    (description) => description?.language === language,
  );
  return description?.text;
};
